export function roundOffCost(cost) {
  cost = Math.round(cost * 100) / 100;
  return cost.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    style: "currency",
    currency: "INR",
  });
}
// export function roundOffCost(inrCost, conversionRate = 0.044) {
//   // Convert INR to AED using the given rate
//   let aedCost = inrCost * conversionRate;

//   // Round to 2 decimal places
//   aedCost = Math.round(aedCost * 100) / 100;

//   // Format as Dirham currency
//   return aedCost.toLocaleString("en-AE", {
//     style: "currency",
//     currency: "AED",
//     maximumFractionDigits: 2,
//   });
// }
// export function roundOffCostWithNoFraction(cost, conversionRate = 0.044) {
//   let aedCost = cost * conversionRate;
//   cost = Math.round(aedCost * 100) / 100;
//   return cost.toLocaleString("en-AE", {
//     maximumFractionDigits: 0,
//     style: "currency",
//     currency: "AED",
//   });
// }
// export function roundOffCost(inrCost, conversionRate = 1 / 95.74) {
//   let usdCost = inrCost * conversionRate;

//   usdCost = Math.round(usdCost * 100) / 100;

//   return usdCost.toLocaleString("en-US", {
//     style: "currency",
//     currency: "USD",
//     maximumFractionDigits: 2,
//   });
// }
export function roundOffCostWithNoFraction(cost) {
  cost = Math.round(cost * 100) / 100;
  return cost.toLocaleString("en-IN", {
    maximumFractionDigits: 0,
    style: "currency",
    currency: "INR",
  });
}
// export function roundOffCostWithNoFraction(
//   inrCost,
//   conversionRate = 1 / 95.74
// ) {
//   let usdCost = inrCost * conversionRate;

//   usdCost = Math.round(usdCost * 100) / 100;

//   return usdCost.toLocaleString("en-US", {
//     style: "currency",
//     currency: "USD",
//     maximumFractionDigits: 0,
//   });
// }

export function roundOffCostWithoutRupee(cost) {
  return (cost = Math.round(cost * 100) / 100);
}
// export function roundOffCostWithoutRupee(cost, conversionRate = 1 / 95.74) {
//   let usdCost = cost * conversionRate;

//   return (cost = Math.round(usdCost * 100) / 100);
// }

var a = [
  "",
  "One ",
  "Two ",
  "Three ",
  "Four ",
  "Five ",
  "Six ",
  "Seven ",
  "Eight ",
  "Nine ",
  "Ten ",
  "Eleven ",
  "Twelve ",
  "Thirteen ",
  "Fourteen ",
  "Fifteen ",
  "Sixteen ",
  "Seventeen ",
  "Eighteen ",
  "Nineteen ",
];
var b = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

export function convertRupeesToWords(num) {
  num = Math.floor(num);
  if ((num = num.toString()).length > 9) return "overflow";
  let n = ("000000000" + num)
    .substr(-9)
    .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
  if (!n) return;
  var str = "";
  str +=
    n[1] != 0
      ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "Crore "
      : "";
  str +=
    n[2] != 0
      ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "Lakh "
      : "";
  str +=
    n[3] != 0
      ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "Thousand "
      : "";
  str +=
    n[4] != 0
      ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "Hundred "
      : "";
  str +=
    n[5] != 0
      ? (str != "" ? "And " : "") +
        (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]]) +
        "Only."
      : "";
  if (str?.includes("Only")) {
    return str;
  }
  return str + "Only.";
}

// // inr to dhirem

// // const a = [
// //   "",
// //   "One ",
// //   "Two ",
// //   "Three ",
// //   "Four ",
// //   "Five ",
// //   "Six ",
// //   "Seven ",
// //   "Eight ",
// //   "Nine ",
// //   "Ten ",
// //   "Eleven ",
// //   "Twelve ",
// //   "Thirteen ",
// //   "Fourteen ",
// //   "Fifteen ",
// //   "Sixteen ",
// //   "Seventeen ",
// //   "Eighteen ",
// //   "Nineteen ",
// // ];

// // const b = [
// //   "",
// //   "",
// //   "Twenty ",
// //   "Thirty ",
// //   "Forty ",
// //   "Fifty ",
// //   "Sixty ",
// //   "Seventy ",
// //   "Eighty ",
// //   "Ninety ",
// // ];

// // function numToWords(num) {
// //   if (num === 0) return "Zero ";
// //   let str = "";

// //   if (num > 999999) {
// //     str += numToWords(Math.floor(num / 1000000)) + "Million ";
// //     num %= 1000000;
// //   }
// //   if (num > 999) {
// //     str += numToWords(Math.floor(num / 1000)) + "Thousand ";
// //     num %= 1000;
// //   }
// //   if (num > 99) {
// //     str += a[Math.floor(num / 100)] + "Hundred ";
// //     num %= 100;
// //   }
// //   if (num > 0) {
// //     str +=
// //       (str !== "" ? "and " : "") +
// //       (a[num] || b[Math.floor(num / 10)] + a[num % 10]);
// //   }
// //   return str;
// // }

// // export function convertRupeesToWords(inrAmount, conversionRate = 0.044) {
// //   const aedAmount = +(inrAmount * conversionRate).toFixed(2);
// //   const whole = Math.floor(aedAmount);
// //   const fils = Math.round((aedAmount - whole) * 100);

// //   let result = "";

// //   if (whole > 0) result += numToWords(whole) + "Dirhams";
// //   if (fils > 0) result += (result ? " and " : "") + numToWords(fils) + "Fils";
// //   if (!result) result = "Zero Dirhams";

// //   return result.trim() + " only";
// // }

// // inr to usd

// const a = [
//   "",
//   "One ",
//   "Two ",
//   "Three ",
//   "Four ",
//   "Five ",
//   "Six ",
//   "Seven ",
//   "Eight ",
//   "Nine ",
//   "Ten ",
//   "Eleven ",
//   "Twelve ",
//   "Thirteen ",
//   "Fourteen ",
//   "Fifteen ",
//   "Sixteen ",
//   "Seventeen ",
//   "Eighteen ",
//   "Nineteen ",
// ];

// const b = [
//   "",
//   "",
//   "Twenty ",
//   "Thirty ",
//   "Forty ",
//   "Fifty ",
//   "Sixty ",
//   "Seventy ",
//   "Eighty ",
//   "Ninety ",
// ];

// function numToWords(num) {
//   if (num === 0) return "Zero ";

//   let str = "";

//   if (num > 999999) {
//     str += numToWords(Math.floor(num / 1000000)) + "Million ";
//     num %= 1000000;
//   }

//   if (num > 999) {
//     str += numToWords(Math.floor(num / 1000)) + "Thousand ";
//     num %= 1000;
//   }

//   if (num > 99) {
//     str += a[Math.floor(num / 100)] + "Hundred ";
//     num %= 100;
//   }

//   if (num > 0) {
//     str +=
//       (str !== "" ? "and " : "") +
//       (a[num] || b[Math.floor(num / 10)] + a[num % 10]);
//   }

//   return str;
// }

// export function convertRupeesToWords(inrAmount, conversionRate = 1 / 95.74) {
//   // Convert INR to USD
//   const usdAmount = +(inrAmount * conversionRate).toFixed(2);

//   const whole = Math.floor(usdAmount);

//   const cents = Math.round((usdAmount - whole) * 100);

//   let result = "";

//   if (whole > 0) {
//     result += numToWords(whole) + "Dollars";
//   }

//   if (cents > 0) {
//     result += (result ? " and " : "") + numToWords(cents) + "Cents";
//   }

//   if (!result) {
//     result = "Zero Dollars";
//   }

//   return result.trim() + " only";
// }
